import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "../api";

"use strict";
ko.bindingHandlers.optionspicker = {
    init: function(elt, va, bindings, model, context) {
        var child_model = {
            items: ko.observableArray([]),
            available_items: ko.observableArray([]),
            select_item: function(ui, e) {
                console.log("select uitem:", ui);
                child_model.changing(true);
                try {
                    child_model.available_items(child_model.available_items().filter((v) => v.value != ui.value));
                    child_model.items.push(ui);
                    child_model._update_source();
                }
                finally {
                    child_model.changing(false);
                }
            },
            unselect_item: function(ui) {
                child_model.changing(true);
                try {
                    child_model.available_items.push(ui);
                    child_model.items(child_model.items().filter((v) => v.value != ui.value));
                    child_model._update_source();
                }
                finally {
                    child_model.changing(false);
                }
            },
            _update_source: function() {
                va()(child_model.items().map((v)=>v.value));
                if (ko.isObservable(bindings().available)) {
                    bindings().available(child_model.available_items().map((v)=>v.value));
                }

            },
            changing: ko.observable(false)
        };

        $(elt).data("optionspicker", child_model);
        ko.applyBindingsToDescendants(context.createChildContext(child_model), elt);
        return { "controlsDescendantBindings": true};

    },
    update: function(elt, va, bindings) {
        var model = $(elt).data("optionspicker");
        if (model.changing()) return;
        try {
            model.changing(true);
            model.items(va()().map((v) => { return {"caption": v, "value": v }; }));
            model.available_items(
                    (ko.unwrap(bindings().available()) || []).map((v) => {
                        return {"caption": v, "value": v };
                    })
                );
        } finally {
            model.changing(false);
        }
    }
};